<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Message Templates' }}</h2>
      <p>The text per channel + event — the WHAT of a message. A partner row overrides the Global default.</p>
    </div>
    <div class="head-actions">
      <p-button label="Send Message" icon="pi pi-send" [outlined]="true" (onClick)="sendDlg.open()" />
      <p-button label="New Template" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>
  </div>

  <div class="card">
    <div class="toolbar">
      <p-iconfield iconPosition="left" class="search-field">
        <p-inputicon styleClass="pi pi-search" />
        <input type="text" pInputText placeholder="Filter by template key, then Enter..."
          [ngModel]="keyFilter()" (ngModelChange)="keyFilter.set($event)" (keyup.enter)="load()">
      </p-iconfield>
      <div class="filter">
        <label>Channel</label>
        <p-select [ngModel]="channelFilter()" (ngModelChange)="onChannelFilter($event)"
          [options]="channels" [showClear]="true" placeholder="All channels" appendTo="body" />
      </div>
      <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
    </div>

    <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th>Template Key</th>
          <th>Channel</th>
          <th>Scope</th>
          <th>Provider Template</th>
          <th>Subject</th>
          <th>Active</th>
          <th class="ta-r">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td class="mono">{{ r.templateKey }}</td>
          <td><p-tag [value]="r.channel" severity="info" /></td>
          <td>
            @if (r.partnerId == null && r.clientId == null) {
              <p-tag value="Global" severity="contrast"
                pTooltip="Default used when no client- or partner-specific row exists." />
            } @else {
              <span pTooltip="Overrides the Global default for this key + channel.">{{ scopeLabel(r) }}</span>
            }
          </td>
          <td class="mono provider-col">
            @if (r.providerTemplateId) {
              <span pTooltip="Approved provider template (Meta name / DLT id) — the send goes out as a real template.">
                {{ r.providerTemplateId }}</span>
            } @else if (r.channel === 'WHATSAPP') {
              <span class="warn-cell"
                pTooltip="No approved template name — WhatsApp only delivers this inside a 24h customer-service window.">
                <i class="pi pi-exclamation-triangle"></i> free-form</span>
            } @else {
              —
            }
          </td>
          <td class="subject">{{ r.channel === 'EMAIL' ? (r.subject || '—') : '—' }}</td>
          <td>
            <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
              <p-tag [value]="r.isActive ? 'Active' : 'Inactive'"
                [severity]="r.isActive ? 'success' : 'secondary'" />
            </span>
          </td>
          <td class="ta-r actions">
            <p-button icon="pi pi-send" [rounded]="true" [text]="true" severity="info"
              pTooltip="Send test" (onClick)="sendDlg.open(r.templateKey)" />
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">
            <div class="state"><i class="pi pi-inbox"></i>
              <p>No message templates found.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Message Template' : 'New Message Template'" styleClass="menu-dialog"
  [style]="{ width: '720px' }" [breakpoints]="{ '720px': '96vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="grid-3">
      <div class="field">
        <label>Channel <span class="req">*</span></label>
        <p-select formControlName="channel" [options]="channels" placeholder="Select channel" appendTo="body" />
        @if (form.get('channel')?.touched && form.get('channel')?.invalid) {
          <small class="err">Channel is required</small>
        }
      </div>
      <div class="field">
        <label>Template Key <span class="req">*</span></label>
        <p-select formControlName="templateKey" [options]="templateKeys" [editable]="true"
          placeholder="OTP_VERIFICATION" appendTo="body" />
        @if (form.get('templateKey')?.touched && form.get('templateKey')?.invalid) {
          <small class="err">Template key is required</small>
        }
      </div>
      <div class="field">
        <label>Scope <span class="req">*</span></label>
        <p-select formControlName="scopeType" [options]="scopeTypes" optionLabel="label"
          optionValue="value" appendTo="body" (onChange)="onScopeChange()" />
      </div>
      @if (form.get('scopeType')?.value === 'PARTNER') {
        <div class="field">
          <label>Partner <span class="req">*</span></label>
          <p-select formControlName="partnerId" [options]="partnerOptions()" optionLabel="label"
            optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
            placeholder="Select a partner" appendTo="body" />
          @if (form.get('partnerId')?.touched && !form.get('partnerId')?.value) {
            <small class="err">Choose a partner, or set Scope back to Global.</small>
          }
        </div>
      } @else if (form.get('scopeType')?.value === 'CLIENT') {
        <div class="field">
          <label>Client <span class="req">*</span></label>
          <p-select formControlName="clientId" [options]="clientOptions()" optionLabel="label"
            optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
            placeholder="Select a client" appendTo="body" />
          @if (form.get('clientId')?.touched && !form.get('clientId')?.value) {
            <small class="err">Choose a client, or set Scope back to Global.</small>
          }
        </div>
      }
    </div>

    @if (isEmail) {
      <div class="field">
        <label>Subject <span class="req">*</span></label>
        <input pInputText type="text" formControlName="subject" placeholder="Your OTP for verification">
      </div>
    }

    <!-- placeholder helper chips -->
    <div class="field">
      <label>Body <span class="req">*</span></label>
      <div class="chips">
        <span class="chips-label">Insert:</span>
        @for (p of placeholders; track p) {
          <button type="button" class="chip" (click)="insertPlaceholder(p, bodyArea)">{{ tpl(p) }}</button>
        }
      </div>
      <textarea #bodyArea class="form-textarea" rows="5" formControlName="body"
        [placeholder]="bodyPlaceholder"></textarea>
      @if (form.get('body')?.touched && form.get('body')?.invalid) {
        <small class="err">Body is required</small>
      }
      @if (unknownPlaceholders.length) {
        <small class="warn">
          <i class="pi pi-exclamation-triangle"></i>
          Unknown placeholder(s): {{ unknownPlaceholders.join(', ') }} — these won't be substituted.
        </small>
      }
      <!-- The provider's positional 1..n parameters are derived from the body, in this order —
           it must match what the template was registered with. -->
      @if (bodyParams.length) {
        <small class="hint-muted">
          {{ bodyParams.length }} parameter{{ bodyParams.length === 1 ? '' : 's' }} sent to the
          provider: {{ bodyParams.join(', ') }} <span class="dim">(first-appearance order)</span>
        </small>
      }
      @if (isWhatsApp && isOtpKey && bodyPlaceholderCount !== 1) {
        <small class="err">
          A WhatsApp OTP body must contain exactly one placeholder — the code. Meta renders the
          expiry and "do not share" lines itself; typing them here makes the template unapprovable.
        </small>
      }
    </div>

    @if (hasProviderTemplate) {
      <div class="field">
        <label>Provider Template {{ isWhatsApp ? 'Name' : 'ID' }}</label>
        <input pInputText type="text" formControlName="providerTemplateId"
          [placeholder]="isWhatsApp ? 'Approved Meta template name, e.g. arogya_otp' : 'DLT template id'">
        @if (whatsAppNeedsTemplateName) {
          <small class="warn">
            <i class="pi pi-exclamation-triangle"></i>
            Without an approved template name this goes out free-form, which Meta only delivers
            within 24h of the customer messaging you — business-initiated sends reach almost nobody.
          </small>
        }
      </div>
    }

    @if (isWhatsApp) {
      <div class="grid-3">
        <div class="field">
          <label>Template Language</label>
          <input pInputText type="text" formControlName="providerTemplateLang" placeholder="en">
          <small class="hint-muted">Name + language identify the template at Meta; a mismatch fails as "not found".</small>
        </div>
        @if (!bodyHasLink) {
          <div class="field span-2">
            <label>Button Base URL</label>
            <input pInputText type="text" formControlName="providerButtonUrlBase"
              placeholder="https://rzp.io/i/ — only if the approved template has a dynamic URL button">
            <small class="hint-muted">
              The fixed base the button was registered with; the send supplies only the piece of
              the link after it. Its domain must match the links this key actually sends
              (rzp.io for payment links). Blank = no button.
            </small>
          </div>
        }
      </div>
    }

    <!-- live preview -->
    <div class="preview">
      <div class="preview-head"><i class="pi pi-eye"></i> Preview <small>(Otp=123456, Name=Ramesh, Minutes=5)</small></div>
      @if (isEmail && previewSubject) {
        <div class="preview-subject"><b>Subject:</b> {{ previewSubject }}</div>
      }
      @if (isEmail) {
        <div class="preview-body" [innerHTML]="previewBody"></div>
      } @else {
        <pre class="preview-body">{{ previewBody }}</pre>
      }
    </div>

    <p-checkbox [binary]="true" formControlName="isActive" label="Active (resolved at send time)" styleClass="check" />

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button label="Save" (onClick)="save()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>

<!-- Compose + queue (File/Upload → Notification/SendTemplate). Opened from the toolbar
     (blank) or a row's "Send test" action (key preselected). -->
<app-send-message-dialog #sendDlg [templates]="rows()" [partnerOptions]="partnerOptions()"
  [clientOptions]="clientOptions()" />

